import { callProcedure, transformToProcedurePayload } from 'clickNgo/helpers/api'
import type { FinancialMetricMode } from 'partner360/entities/financialMetricMode'

export type ConfirmTnetReviewParams = {
  partnerId: string
  fYear: number
  programType: string
  category?: string | null
  reviewMetricMode: FinancialMetricMode
}

const REVIEW_ACTION_BY_METRIC_MODE: Record<FinancialMetricMode, string> = {
  tnet: 'TNet Review',
  ndp: 'NDP Review',
  net: 'Net Review',
}

export const confirmTnetReview = async (params: ConfirmTnetReviewParams): Promise<void> => {
  const procedureParams = {
    partnerId: params.partnerId,
    fYear: params.fYear,
    programType: params.programType,
    ...(params.category ? { category: params.category } : {}),
  }

  const response = await callProcedure({
    url: '/webservice/621/sp/v3/spJBPPlanReview/call',
    method: 'POST',
    data: {
      ...transformToProcedurePayload(procedureParams),
      'p.Action': REVIEW_ACTION_BY_METRIC_MODE[params.reviewMetricMode],
    },
  })

  if ('error' in response) {
    throw response.error
  }
}
